import {action} from 'mobx';
import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';
import ModelState, {localised} from './_util/model';
import QS from 'qs';
import autobind from 'autobind-decorator';

class GetCategoriesContentState extends APIRequestState {
  get url() { return '/content/categories'; }
  get method() { return 'GET'; }
  get singular() { return 'category'; }
  get plural() { return 'categories'; }
}

class GetSingleCategoriesContentState extends APIRequestState {
  getRequest(urlId, urlParams) {
    return this.ctx.sdk.get(`/content/categories/${urlId}?${QS.stringify(urlParams)}`);
  }
}

class GetV4CategoriesContentState extends APIRequestState {
  getRequest(urlId, urlParams) {
    return this.ctx.sdk.get(`/v4/categories/${urlId}?${QS.stringify(urlParams)}`);
  }
}

class GetV4CategoriesSubCategoriesState extends APIRequestState {
  getRequest(urlId, urlParams) {
    return this.ctx.sdk.get(`/v4/categories/${urlId}/sub-categories?${QS.stringify(urlParams)}`);
  }
}

class GetV4CategoriesSpecialitiesState extends APIRequestState {
  getRequest(urlId, urlParams) {
    return this.ctx.sdk.get(`/v4/categories/${urlId}/specialities?${QS.stringify(urlParams)}`);
  }
}

// TODO should be in a specialities state
class GetV2SpecialityContentByStub extends APIRequestState {
  getRequest(urlId, urlParams) {
    return this.ctx.sdk.get(`/v2/specialities/${urlId}?${QS.stringify(urlParams)}`);
  }
}

class GetV2SpecialityDurationsByStub extends APIRequestState {
  getRequest(urlId, urlParams) {
    return this.ctx.sdk.get(`/v2/specialities/${urlId}/durations?${QS.stringify(urlParams)}`);
  }
}

// MODELS

@localised
class ContentCategoriesModelState extends ModelState {
  // categories model state is localised, so it adds '::en-gb' to the modelKey in the localised getModelKey function, for this reason we need to sanitize it here, by removing the locale from the id
  sanitizeModelId(id) {
    const n = id.indexOf(':');
    const tempId = id.substring(0, n !== -1 ? n : id.length);

    return `${tempId}`;
  }

  // get url() { return '/content/categories'; }
  get url() { return '/content/categories'; }
  get singular() { return 'category'; }
  get plural() { return 'categories'; }
}

@localised
class ContentCategoryByStubModelState extends ModelState {
  // categories model state is localised, so it adds '::en-gb' to the modelKey in the localised getModelKey function, for this reason we need to sanitize it here, by removing the locale from the id
  sanitizeModelId(id) {
    const n = id.indexOf(':');
    const tempId = id.substring(0, n !== -1 ? n : id.length);

    return `${tempId}`;
  }

  get method() { return 'GET'; }
  get url() { return '/content/categories'; }
  get singular() { return 'group'; }
  get plural() { return 'groups'; }
  get extra() { return ['category', 'subcategories', 'footerText', 'headerText']; }

  @autobind @action loadSearch(search, ...params) {
    const id = this.getSearchKey(search);
    if (!this.searches.has(id)) {
      this.searches.set(id, new this.Search(this, id, search));
    }
    return this.searches.get(id).loadNew(...params);
  }

  getSearchRequest(search, ...params) {
    const [urlStub] = params;

    if (!this.url) {
      throw new Error('Missing option `url`');
    }

    if (!this.singular) {
      throw new Error('Missing option `singular`');
    }

    return this.ctx.sdk.get(`${this.url}/${urlStub}?${QS.stringify(search.search)}`);
  }
}

class CategoriesState {
  /*
   * Lazy load our required state
   */
  @lazyInitialize @nonenumerable contentCategoriesModel = new ContentCategoriesModelState(this.ctx);
  @lazyInitialize @nonenumerable contentCategoriesStubModel = new ContentCategoryByStubModelState(this.ctx);
  // Booking flow
  @lazyInitialize @nonenumerable getCategoriesContent = new GetCategoriesContentState(this.ctx);
  @lazyInitialize @nonenumerable getSingleCategoriesContent = new GetSingleCategoriesContentState(this.ctx);

  // New Basket endpoints
  @lazyInitialize @nonenumerable getV4CategoriesContent = new GetV4CategoriesContentState(this.ctx);
  @lazyInitialize @nonenumerable getV4CategoriesSubCategories = new GetV4CategoriesSubCategoriesState(this.ctx);
  @lazyInitialize @nonenumerable getV4CategoriesSpecialities = new GetV4CategoriesSpecialitiesState(this.ctx);
  @lazyInitialize @nonenumerable getV2SpecialityContentByStub = new GetV2SpecialityContentByStub(this.ctx);
  @lazyInitialize @nonenumerable getV2SpecialityDurationsByStub = new GetV2SpecialityDurationsByStub(this.ctx);

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }
}

export default CategoriesState;



// WEBPACK FOOTER //
// ./spa/state/categories.jsx